import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Heading, Text } from '@radix-ui/themes';

const EventDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Box p="2">
      <Heading size="6" mb="3">
        Event Detail
      </Heading>
      <Text>Placeholder page for event: {id}</Text>
      <Text size="2" color="gray" mt="2">
        This page will display detailed information about a specific decoded
        event.
      </Text>
    </Box>
  );
};

export default EventDetail;
